module.exports = __webpack_public_path__ + "static/media/life-earn-point-banner-mobile.6d81eccb.jpg";